import styled from 'styled-components';
import COLORS from 'constants/colors';

export const Thumbnail = styled.button`
  position: relative;
  width: 64px;
  height: 48px;
  border-radius: 6px;
  border: 2px solid ${({ isActive }) => (isActive ? COLORS.COLA : COLORS.GALLERY)};
  background: ${COLORS.WHITE};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${COLORS.COLA_LIGHT};
  }
`;

export const ViewedDot = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${COLORS.GREEN_5};
  border: 2px solid ${COLORS.WHITE};
`;
